import { all, fork, takeLatest, takeEvery } from 'redux-saga/effects';
import { fetchDetailWithCallbacks, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchCompletedTable() {
  yield takeLatest('applicationsCompleted/fetchTable', fetchTable);
}

function* watchFetchCompletedDetail() {
  yield takeLatest('applicationsCompleted/fetchDetail', fetchDetailWithCallbacks);
}

function* watchSubmitCompletedDetail() {
  yield takeEvery('applicationsCompleted/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchCompletedTable),
    fork(watchFetchCompletedDetail),
    fork(watchSubmitCompletedDetail)
  ]);
}
